<template>
  <div class="">
    <div class="flexbox m-b-md justify-center box-base-table-search">
      <div class="flex-grow sale-detail-search gap-10">
        <div class="search-block search-block-date datepicker-start">
          <label class="m-r-sm m-b-none">日付From </label>
          <div>
            <date-picker
              v-model="start"
              :not-after="end"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerEnd)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-date datepicker-end">
          <label class="m-r-sm m-b-none">日付To </label>
          <div>
            <date-picker
              v-model="end"
              :not-before="start"
              placeholder=""
              ref="datepickerEnd"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerStart)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-detail">
          <label class="m-r-sm m-b-none">明細 </label>
          <input type="text" class="form-control m-r-sm" v-model.trim="detail" name="detail" @keydown.enter="onHandleSearch">
          <div class="box-detail-btn-search">
            <button class="btn btn-warning ver-middle w-120" @click="onHandleSearch">フィルター</button>
          </div>
        </div>
        <div class="box-btn-download-csv">
          <button class="btn btn-primary w-120" @click="confirmDownloadCsv()">ダウンロード</button>
        </div>
        <pagination
          :totalPage="totalPage"
          :currentPage="currentPage"
          :paginationStorageKey="paginationStorageKey"
          @updateCurrentPage="updateCurrentPage"
        />
      </div>
    </div>
    <div class="table-wrapper" ref="table">
      <table class="table table-bordered common-table widthedTable" :class="tableClass">
        <thead>
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :class="column.headerClass"
              :key="index"
              :style="{width: column.width}"
              v-html="column.title"
            />
          </tr>
        </thead>
        <tbody>
          <tr v-if="!initial && countTableData() === 0">
            <td :colspan="columns.length" class="bg-danger text-danger text-center"><h5 style="font-weight: 600">データが見つかりません。</h5></td>
          </tr>
          <tr v-for="(item, index) in pageData" :key="index" v-else>
            <td
              v-for="(column, colIndex) in columns"
              :key="index + '-' + colIndex"
              :class="column.cellClass"
              :style="{width: column.width}"
            >
              <template>
                <slot :name="column.name" :row-data="item" :data="defaultData"></slot>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <get-data
      :url="this.url"
      @onChangePage="onChangePage"
      @zIndex="$emit('zIndex', $event)"
      :keyword="filters"
      :maxRows="maxRows"
      :method="method"
      ref="pagination"
      @updateTotalPage="updateTotalPage"
      :currentPage="currentPage"
      @updateCurrentPage="updateCurrentPage"
    />
    <pagination
      v-if="defaultData.length >= 50"
      class="justify-center mr-t-10"
      :totalPage="totalPage"
      :currentPage="currentPage"
      :paginationStorageKey="paginationStorageKey"
      @updateCurrentPage="updateCurrentPage"
    />
  </div>
</template>
<script>
import Pagination from '@/components/PaginationNextPage'
import GetData from '@/components/FetchDataAPI'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
export default {
  components: {
    DatePicker,
    Pagination,
    GetData
  },
  data () {
    return {
      pageData: [],
      defaultData: [],
      initial: true,
      filters: this.searchValue || null,
      start: null,
      end: null,
      detail: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      totalPage: 0,
      currentPage: 1,
      isLoadMore: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    tableClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: Object,
      default () {
        return {
          detail: null,
          from: null,
          to: null
        }
      }
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    },
    paginationStorageKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  methods: {
    closePopup (dom) {
      dom.closePopup()
    },
    /*
     * Handle on page change
     *
     * @param {Array} data All Data for table from API
     * @param {Object} extraData Extra data get from API
     * @param {Boolean} needClear Nead clear previous data to store a new one
     *
     * @return void
     */
    onChangePage (data) {
      this.defaultData = [...data]
      this.pageData = this.defaultData.slice(0, 100)

      if (this.initial) {
        this.initial = false
      }
      this.isLoadMore = false
    },
    countTableData () {
      return this.defaultData.length
    },
    /*
     * Handle onclick search button
     *
     * @return void
     */
    onHandleSearch () {
      this.filters = {
        from: this.start ? moment(this.start).format('YYYY/MM/DD 00:00:00') : null,
        to: this.end ? moment(this.end).format('YYYY/MM/DD 23:59:59') : null,
        detail: this.detail
      }
      this.$emit('onHandleSearch')
    },
    /*
     * Handle onclick reload button
     *
     * @param {Boolean} showLoading Need show loading for table
     * @param {Boolean} keepKeyword Is remove current keyword or not
     *
     * @return void
     */
    reload () {
      this.$refs.pagination.reload()
    },
    confirmDownloadCsv () {
      this.$emit('confirmDownloadCsv')
    },
    updateCurrentPage (val) {
      this.currentPage = val
    },
    updateTotalPage (val) {
      this.totalPage = val
    },
    loadMoreData () {
      if (this.isLoadMore) {
        return false
      }
      const scrollPosition = window.innerHeight + window.scrollY
      const bottomPosition = document.documentElement.scrollHeight
      if (bottomPosition / 2 - scrollPosition < 0) {
        this.isLoadMore = true
        const loadDataRow = 100
        const startIndex = this.pageData.length
        if (startIndex >= this.defaultData.length) {
          return false
        }
        const endIndex = startIndex + loadDataRow
        const loadMoreData = [...this.defaultData].slice(startIndex, endIndex)
        setTimeout(() => {
          this.isLoadMore = false
        }, 500)
        this.pageData = [...this.pageData, ...loadMoreData]
        loadMoreData.length = 0
      }
    },
    handleUpdateFilters () {
      const filters = {
        from: this.start ? moment(this.start).format('YYYY/MM/DD 00:00:00') : null,
        to: this.end ? moment(this.end).format('YYYY/MM/DD 23:59:59') : null,
        detail: this.detail
      }
      this.$emit('updateFilters', filters)
    }
  },
  mounted () {
    $('.datepicker-start .mx-input-append').click((evt) => {
      $('.datepicker-start .mx-input').focus()
    })
    $('.datepicker-end .mx-input-append').click((evt) => {
      $('.datepicker-end .mx-input').focus()
    })
    window.addEventListener('scroll', this.loadMoreData)
  },
  unmouted () {
    window.removeEventListener('scroll', this.loadMoreData)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.loadMoreData)
  },
  watch: {
    start () {
      this.handleUpdateFilters()
    },
    end () {
      this.handleUpdateFilters()
    },
    detail () {
      this.handleUpdateFilters()
    }
  }
}
</script>

<style scoped>
.search-block {
  margin-right: unset;
}
@media (min-width: 1201px) {
  .search-block-detail input {
    width: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/ExpenseDetailTable.vue